import styled from '@emotion/styled';

export const LoadingPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  gap: 30px;
`;

export const LoadingPageText = styled.p`
  color: ${({theme}) => theme?.color?.black ?? 'black'};
  font-size: ${({theme}) => theme?.typography?.fontSize.lg ?? '16px'};
`;
